const messageKeys = {
    TelNumberInvalid: 'mobileInvalid',
    SmsSendFailed: 'sendFailed',
    CodeExpired: 'codeExpired',
    TooManyAttempts: 'tooManyAttempts',
    CodeInvalid: 'codeInvalid',
    AlreadySigned: 'handoff.alreadySigned'
}

// Every failure has to be visible: a code costs a real SMS and is rate limited, so a silently dead button
// leaves the registrant pressing it again without ever learning why nothing happens.
export function commitmentErrorMessage(t, error, fallbackKey) {
    if (error.response?.status === 429) return t('eventRegistration.commitment.tooManyRequests')

    return t('eventRegistration.commitment.' + (messageKeys[error.response?.data?.message] ?? fallbackKey))
}
